/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TheMask } from "vue-the-mask";
import { Money } from "v-money";

const __vue_script__ = {
  components: {
    TheMask,
    Money
  },
  props: [
    "nonumber",
    "nospecial",
    "label",
    "icon",
    "type",
    "placeholder",
    "mobilePlaceholder",
    "id",
    "value",
    "errors",
    "readonly",
    "disabled",
    "required",
    "mask",
    "masked",
    "isPhone",
    "select",
    "options",
    "isMoney",
    "helpIcon",
    "maxlength"
  ],
  data() {
    return {
      innerValue: this.value,
      showError: false,
      isMobile: false,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    error() {
      return this.errors ? this.errors[0] : "";
    },
    innerLabel() {
      return this.isMobile ? null : this.label;
    },
    innerPlaceholder() {
      if (this.mobilePlaceholder && this.isMobile) return this.mobilePlaceholder;
      return (this.isMobile && this.label) ? this.label : this.placeholder;
    }
  },
  watch: {
    errors(newVal) {
      if (newVal && newVal.length) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    innerValue(newVal) {
      if (newVal != this.value) {
        this.showError = false;
        this.$emit("input", newVal);
      }
      if (this.isPhone && newVal.match(/[a-zA-Z]/)) {
        setTimeout(() => {
          this.innerValue = newVal.replace(/[a-zA-Z]/, "");
        }, 2);
      }
    },
    value(newVal) {
      if (this.innerValue !== newVal) {
        this.innerValue = newVal;
      }
    }
  },
  mounted() {
    checkIsMobile = () => this.isMobile = window.innerWidth < 992;
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
  },
  methods: {
    preventInput($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (this.nonumber && keyCode > 47 && keyCode < 58) {
        $event.preventDefault();
      }
      if (this.nospecial && ((keyCode > 32 && keyCode < 65) || (keyCode > 90 && keyCode < 96) || (keyCode > 122 && keyCode < 126))) {
        $event.preventDefault();
      }
    },
    countryChanged(obj) {
      this.$emit("country-changed", obj);
      setTimeout(function() {
        this.innerValue = document.querySelector(`#${this.id} input`).value;
      }, 1);
    },
    validate(obj) {
      this.$emit('validate', obj);
    },
    closeHelp() {
      this.$emit('close-help');
    }
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group",
      class: {
        "has-icon": !!_vm.icon,
        "has-label": !!_vm.innerLabel,
        "has-help": !!_vm.helpIcon,
        "is-empty": !_vm.innerValue,
        "is-phone": _vm.isPhone,
      },
    },
    [
      _vm.innerLabel
        ? _c("label", { attrs: { for: _vm.id } }, [
            _vm._v("\n    " + _vm._s(_vm.innerLabel) + "\n    "),
            _vm.helpIcon
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.closeHelp,
                        expression: "closeHelp",
                      },
                    ],
                    staticClass: "help-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggle-help")
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-help" })]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.innerLabel && _vm.helpIcon
        ? _c(
            "button",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.closeHelp,
                  expression: "closeHelp",
                },
              ],
              staticClass: "help-button outside-label",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("toggle-help")
                },
              },
            },
            [_c("i", { staticClass: "icon-help" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.icon ? _c("i", { class: "icon " + _vm.icon }) : _vm._e(),
      _vm._v(" "),
      _vm.select
        ? _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.innerValue,
                  expression: "innerValue",
                },
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.showError },
              attrs: {
                id: _vm.id,
                name: _vm.id,
                readonly: _vm.readonly,
                required: _vm.required,
                disabled: _vm.disabled,
              },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.innerValue = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.options, function (option, index) {
              return _c(
                "option",
                { key: index, domProps: { value: option.id } },
                [_vm._v("\n      " + _vm._s(option.name) + "\n    ")]
              )
            }),
            0
          )
        : _vm.isMoney
        ? _c(
            "money",
            _vm._b(
              {
                staticClass: "form-control",
                class: { "is-invalid": _vm.showError },
                attrs: {
                  id: _vm.id,
                  name: _vm.id,
                  type: "tel",
                  placeholder: _vm.innerPlaceholder,
                  readonly: _vm.readonly,
                  required: _vm.required,
                  disabled: _vm.disabled,
                },
                model: {
                  value: _vm.innerValue,
                  callback: function ($$v) {
                    _vm.innerValue = $$v
                  },
                  expression: "innerValue",
                },
              },
              "money",
              _vm.money,
              false
            )
          )
        : _vm.mask
        ? _c("the-mask", {
            staticClass: "form-control",
            class: { "is-invalid": _vm.showError },
            attrs: {
              mask: _vm.mask,
              masked: _vm.masked,
              id: _vm.id,
              name: _vm.id,
              type: _vm.type,
              placeholder: _vm.innerPlaceholder,
              readonly: _vm.readonly,
              required: _vm.required,
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          })
        : _vm.type === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.innerValue,
                expression: "innerValue",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.showError },
            attrs: {
              id: _vm.id,
              name: _vm.id,
              placeholder: _vm.innerPlaceholder,
              readonly: _vm.readonly,
              required: _vm.required,
              disabled: _vm.disabled,
              maxlength: _vm.maxlength,
              type: "checkbox",
            },
            domProps: {
              checked: Array.isArray(_vm.innerValue)
                ? _vm._i(_vm.innerValue, null) > -1
                : _vm.innerValue,
            },
            on: {
              keypress: _vm.preventInput,
              change: function ($event) {
                var $$a = _vm.innerValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.innerValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.innerValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.innerValue = $$c
                }
              },
            },
          })
        : _vm.type === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.innerValue,
                expression: "innerValue",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.showError },
            attrs: {
              id: _vm.id,
              name: _vm.id,
              placeholder: _vm.innerPlaceholder,
              readonly: _vm.readonly,
              required: _vm.required,
              disabled: _vm.disabled,
              maxlength: _vm.maxlength,
              type: "radio",
            },
            domProps: { checked: _vm._q(_vm.innerValue, null) },
            on: {
              keypress: _vm.preventInput,
              change: function ($event) {
                _vm.innerValue = null
              },
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.innerValue,
                expression: "innerValue",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.showError },
            attrs: {
              id: _vm.id,
              name: _vm.id,
              placeholder: _vm.innerPlaceholder,
              readonly: _vm.readonly,
              required: _vm.required,
              disabled: _vm.disabled,
              maxlength: _vm.maxlength,
              type: _vm.type,
            },
            domProps: { value: _vm.innerValue },
            on: {
              keypress: _vm.preventInput,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.innerValue = $event.target.value
              },
            },
          }),
      _vm._v(" "),
      _vm.showError
        ? _c("div", { staticClass: "invalid-feedback" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "none" } }, [
        _vm._v(_vm._s(_vm.nonumber)),
      ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-511a0420_0", { source: ".form-group {\n  position: relative;\n}\n.form-group.has-icon .icon {\n  position: absolute;\n  line-height: 48px;\n  left: 12px;\n  top: 0;\n  font-size: 24px;\n  color: #495057;\n}\n.form-group.has-icon .form-control {\n  padding-left: 42px;\n}\n.form-group.has-icon.has-label .icon {\n  top: 26px;\n}\n.form-group.has-icon.is-empty .icon {\n  color: rgba(33, 38, 49, 0.3);\n}\n.form-group.has-help .form-control.is-invalid, .form-group.has-help .was-validated .form-control:invalid {\n  background-image: none;\n}\n.form-group .form-control {\n  min-height: 48px;\n  border: 1px solid rgba(33, 38, 49, 0.1);\n  border-radius: 6px;\n}\n.form-group .form-control:focus {\n  box-shadow: none;\n}\n.form-group input,\n.form-group .form-control {\n  color: #495057;\n}\n.form-group input::placeholder,\n.form-group .form-control::placeholder {\n  color: rgba(33, 38, 49, 0.3);\n  opacity: 1;\n}\n.form-group.is-empty select {\n  color: rgba(94, 94, 94, 0.4);\n}\n.form-group.is-phone .vti__dropdown {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n.form-group.is-phone .vti__dropdown-list {\n  top: 100%;\n  bottom: auto;\n  right: 0;\n  left: auto;\n  border-radius: 6px;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  padding: 8px 0;\n}\n.form-group.is-phone .vti__dropdown-list .vti__dropdown-item {\n  color: #909398;\n  font-size: 14px;\n  line-height: 24px;\n}\n.form-group.is-phone .vti__dropdown-list .vti__dropdown-item .vti__flag {\n  margin-right: 8px;\n}\nlabel {\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 17px;\n  color: #909398;\n  margin-bottom: 5px;\n}\n\n/*# sourceMappingURL=form-group.vue.map */", map: {"version":3,"sources":["frontend/components/form-group.vue","form-group.vue"],"names":[],"mappings":"AAuMA;EACA,kBAAA;ACtMA;ADyMA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;EACA,cAAA;ACvMA;AD0MA;EACA,kBAAA;ACxMA;AD4MA;EACA,SAAA;AC1MA;AD+MA;EACA,4BAAA;AC7MA;ADmNA;EACA,sBAAA;ACjNA;ADqNA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;ACnNA;ADqNA;EACA,gBAAA;ACnNA;ADuNA;;EAEA,cAAA;ACrNA;ADuNA;;EACA,4BAAA;EACA,UAAA;ACpNA;ADwNA;EACA,4BAAA;ACtNA;AD0NA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;ACxNA;AD2NA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,yCAAA;EACA,cAAA;ACzNA;AD2NA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;ACzNA;AD2NA;EACA,iBAAA;ACzNA;ADgOA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AC7NA;;AAEA,yCAAyC","file":"form-group.vue","sourcesContent":["<template>\n  <div\n    class=\"form-group\"\n    :class=\"{ 'has-icon': !!icon, 'has-label': !!innerLabel, 'has-help': !!helpIcon, 'is-empty': !innerValue, 'is-phone': isPhone }\"\n  >\n    <label :for=\"id\" v-if=\"innerLabel\">\n      {{ innerLabel }}\n      <button class=\"help-button\" v-if=\"helpIcon\" type=\"button\" @click=\"$emit('toggle-help')\" v-click-outside=\"closeHelp\">\n        <i class=\"icon-help\"></i>\n      </button>\n    </label>\n\n    <button class=\"help-button outside-label\" v-if=\"!innerLabel && helpIcon\" type=\"button\" @click=\"$emit('toggle-help')\" v-click-outside=\"closeHelp\">\n      <i class=\"icon-help\"></i>\n    </button>\n\n    <i v-if=\"icon\" :class=\"'icon ' + icon\"></i>\n    <select\n      v-if=\"select\"\n      class=\"form-control\"\n      :class=\"{ 'is-invalid': showError }\"\n      :id=\"id\"\n      :name=\"id\"\n      v-model=\"innerValue\"\n      :readonly=\"readonly\"\n      :required=\"required\"\n      :disabled=\"disabled\"\n    >\n      <option\n        v-for=\"(option, index) in options\"\n        :key=\"index\"\n        :value=\"option.id\"\n      >\n        {{ option.name }}\n      </option>\n    </select>\n    <money\n      v-else-if=\"isMoney\"\n      v-model=\"innerValue\"\n      class=\"form-control\"\n      :class=\"{ 'is-invalid': showError }\"\n      :id=\"id\"\n      :name=\"id\"\n      type=\"tel\"\n      :placeholder=\"innerPlaceholder\"\n      :readonly=\"readonly\"\n      :required=\"required\"\n      :disabled=\"disabled\"\n      v-bind=\"money\"\n    />\n    <the-mask\n      v-else-if=\"mask\"\n      :mask=\"mask\"\n      :masked=\"masked\"\n      v-model=\"innerValue\"\n      class=\"form-control\"\n      :class=\"{ 'is-invalid': showError }\"\n      :id=\"id\"\n      :name=\"id\"\n      :type=\"type\"\n      :placeholder=\"innerPlaceholder\"\n      :readonly=\"readonly\"\n      :required=\"required\"\n      :disabled=\"disabled\"\n    />\n    <input\n      v-else\n      v-model=\"innerValue\"\n      class=\"form-control\"\n      :class=\"{ 'is-invalid': showError }\"\n      :id=\"id\"\n      :name=\"id\"\n      :type=\"type\"\n      :placeholder=\"innerPlaceholder\"\n      :readonly=\"readonly\"\n      :required=\"required\"\n      :disabled=\"disabled\"\n      :maxlength=\"maxlength\"\n      @keypress=\"preventInput\"\n    />\n    <div v-if=\"showError\" class=\"invalid-feedback\">{{ error }}</div>\n    <div style=\"display: none\">{{ nonumber }}</div>\n  </div>\n</template>\n\n<script>\nimport { TheMask } from \"vue-the-mask\";\nimport { Money } from \"v-money\";\n\nexport default {\n  components: {\n    TheMask,\n    Money\n  },\n  props: [\n    \"nonumber\",\n    \"nospecial\",\n    \"label\",\n    \"icon\",\n    \"type\",\n    \"placeholder\",\n    \"mobilePlaceholder\",\n    \"id\",\n    \"value\",\n    \"errors\",\n    \"readonly\",\n    \"disabled\",\n    \"required\",\n    \"mask\",\n    \"masked\",\n    \"isPhone\",\n    \"select\",\n    \"options\",\n    \"isMoney\",\n    \"helpIcon\",\n    \"maxlength\"\n  ],\n  data() {\n    return {\n      innerValue: this.value,\n      showError: false,\n      isMobile: false,\n      money: {\n        decimal: ',',\n        thousands: '.',\n        precision: 2,\n        masked: false\n      }\n    };\n  },\n  computed: {\n    error() {\n      return this.errors ? this.errors[0] : \"\";\n    },\n    innerLabel() {\n      return this.isMobile ? null : this.label;\n    },\n    innerPlaceholder() {\n      if (this.mobilePlaceholder && this.isMobile) return this.mobilePlaceholder;\n      return (this.isMobile && this.label) ? this.label : this.placeholder;\n    }\n  },\n  watch: {\n    errors(newVal) {\n      if (newVal && newVal.length) {\n        this.showError = true;\n      } else {\n        this.showError = false;\n      }\n    },\n    innerValue(newVal) {\n      if (newVal != this.value) {\n        this.showError = false;\n        this.$emit(\"input\", newVal);\n      }\n      if (this.isPhone && newVal.match(/[a-zA-Z]/)) {\n        setTimeout(() => {\n          this.innerValue = newVal.replace(/[a-zA-Z]/, \"\");\n        }, 2);\n      }\n    },\n    value(newVal) {\n      if (this.innerValue !== newVal) {\n        this.innerValue = newVal;\n      }\n    }\n  },\n  mounted() {\n    checkIsMobile = () => this.isMobile = window.innerWidth < 992;\n    checkIsMobile();\n    window.addEventListener('resize', checkIsMobile);\n  },\n  methods: {\n    preventInput($event) {\n      var keyCode = $event.keyCode ? $event.keyCode : $event.which;\n      if (this.nonumber && keyCode > 47 && keyCode < 58) {\n        $event.preventDefault();\n      }\n      if (this.nospecial && ((keyCode > 32 && keyCode < 65) || (keyCode > 90 && keyCode < 96) || (keyCode > 122 && keyCode < 126))) {\n        $event.preventDefault();\n      }\n    },\n    countryChanged(obj) {\n      this.$emit(\"country-changed\", obj);\n      setTimeout(function() {\n        this.innerValue = document.querySelector(`#${this.id} input`).value;\n      }, 1);\n    },\n    validate(obj) {\n      this.$emit('validate', obj);\n    },\n    closeHelp() {\n      this.$emit('close-help');\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\">\n.form-group {\n  position: relative;\n\n  &.has-icon {\n    .icon {\n      position: absolute;\n      line-height: 48px;\n      left: 12px;\n      top: 0;\n      font-size: 24px;\n      color: #495057;\n    }\n\n    .form-control {\n      padding-left: 42px;\n    }\n\n    &.has-label {\n      .icon {\n        top: 26px;\n      }\n    }\n\n    &.is-empty {\n      .icon {\n        color: rgba(33, 38, 49, 0.3);\n      }\n    }\n  }\n\n  &.has-help {\n    .form-control.is-invalid, .was-validated .form-control:invalid {\n      background-image: none;\n    }\n  }\n  \n  .form-control {\n    min-height: 48px;\n    border: 1px solid rgba(33, 38, 49, 0.1);\n    border-radius: 6px;\n\n    &:focus {\n      box-shadow: none;\n    }\n  }\n\n  input,\n  .form-control {\n    color: #495057;\n\n    &::placeholder {\n      color: rgba(33, 38, 49, 0.3);\n      opacity: 1;\n    }\n  }\n\n  &.is-empty select {\n    color: rgba(94, 94, 94, 0.4);\n  }\n\n  &.is-phone {\n    .vti__dropdown {\n      position: absolute;\n      top: 8px;\n      right: 8px;\n    }\n\n    .vti__dropdown-list {\n      top: 100%;\n      bottom: auto;\n      right: 0;\n      left: auto;\n      border-radius: 6px;\n      border: none;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n      padding: 8px 0;\n\n      .vti__dropdown-item {\n        color: #909398;\n        font-size: 14px;\n        line-height: 24px;\n        \n        .vti__flag {\n          margin-right: 8px;\n        }\n      }\n    }\n  }\n}\n\nlabel {\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 17px;\n  color:  #909398;\n  margin-bottom: 5px;\n}\n</style>",".form-group {\n  position: relative;\n}\n.form-group.has-icon .icon {\n  position: absolute;\n  line-height: 48px;\n  left: 12px;\n  top: 0;\n  font-size: 24px;\n  color: #495057;\n}\n.form-group.has-icon .form-control {\n  padding-left: 42px;\n}\n.form-group.has-icon.has-label .icon {\n  top: 26px;\n}\n.form-group.has-icon.is-empty .icon {\n  color: rgba(33, 38, 49, 0.3);\n}\n.form-group.has-help .form-control.is-invalid, .form-group.has-help .was-validated .form-control:invalid {\n  background-image: none;\n}\n.form-group .form-control {\n  min-height: 48px;\n  border: 1px solid rgba(33, 38, 49, 0.1);\n  border-radius: 6px;\n}\n.form-group .form-control:focus {\n  box-shadow: none;\n}\n.form-group input,\n.form-group .form-control {\n  color: #495057;\n}\n.form-group input::placeholder,\n.form-group .form-control::placeholder {\n  color: rgba(33, 38, 49, 0.3);\n  opacity: 1;\n}\n.form-group.is-empty select {\n  color: rgba(94, 94, 94, 0.4);\n}\n.form-group.is-phone .vti__dropdown {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n.form-group.is-phone .vti__dropdown-list {\n  top: 100%;\n  bottom: auto;\n  right: 0;\n  left: auto;\n  border-radius: 6px;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  padding: 8px 0;\n}\n.form-group.is-phone .vti__dropdown-list .vti__dropdown-item {\n  color: #909398;\n  font-size: 14px;\n  line-height: 24px;\n}\n.form-group.is-phone .vti__dropdown-list .vti__dropdown-item .vti__flag {\n  margin-right: 8px;\n}\n\nlabel {\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 17px;\n  color: #909398;\n  margin-bottom: 5px;\n}\n\n/*# sourceMappingURL=form-group.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/form-group.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__